export default "__VITE_ASSET__950be69c__"